import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, useMemo } from "react";
import Button from "../../../Button";
import { EMPTY_OBJ } from "../../../helpers/logic/empties";
import Typography from "../../../Typography";
import { SelectContext } from "../../contexts/SelectContext";
import useToolbar from "../Toolbar/hooks/useToolbar";
import { getNumOfRowsSelected, getSelectAllButtonProps } from "./logic";
import { ActionsContainer, BaseBatchActions, LeftContentContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BatchActions(_ref) {
  var totalNumOfTableRows = _ref.totalNumOfTableRows,
    _ref$entityName = _ref.entityName,
    entityName = _ref$entityName === void 0 ? "Row" : _ref$entityName,
    entityNamePluralised = _ref.entityNamePluralised,
    actions = _ref.actions,
    floating = _ref.floating;
  var _useContext = useContext(SelectContext),
    selectLogic = _useContext.selectLogic,
    selectableRows = _useContext.selectableRows;
  var selectAllButtonProps = useMemo(function () {
    return getSelectAllButtonProps(selectableRows, selectLogic, totalNumOfTableRows, entityName, entityNamePluralised);
  }, [selectableRows, selectLogic, totalNumOfTableRows, entityName, entityNamePluralised]);
  var _ref2 = selectLogic || EMPTY_OBJ,
    state = _ref2.state;
  var _ref3 = state || EMPTY_OBJ,
    ids = _ref3.ids;
  var numOfRowsSelected = ids === null || ids === void 0 ? void 0 : ids.length;
  var numOfRowsSelectedText = useMemo(function () {
    return getNumOfRowsSelected(selectableRows, numOfRowsSelected, totalNumOfTableRows, entityName, entityNamePluralised);
  }, [selectableRows, numOfRowsSelected, totalNumOfTableRows, entityName, entityNamePluralised]);
  var _useToolbar = useToolbar(actions),
    ActionsComponents = _useToolbar.ActionsComponents;
  return /*#__PURE__*/_jsxs(BaseBatchActions, {
    floating: floating,
    children: [/*#__PURE__*/_jsxs(LeftContentContainer, {
      children: [/*#__PURE__*/_jsx(Typography, {
        children: numOfRowsSelectedText
      }), /*#__PURE__*/_jsx(Button, _extends({
        appearance: "link",
        size: "compact"
      }, selectAllButtonProps))]
    }), actions && /*#__PURE__*/_jsx(ActionsContainer, {
      children: ActionsComponents
    })]
  });
}
export default BatchActions;